import {ActiveInfoPageConfig} from '@/components/Ui/ActiveInfoPage/BZCore/ActiveInfoPage'

import newsletterStatus from '@/components/Newsletters/Page/status.vue'
import newsletterStatistic from '@/components/Newsletters/Page/statistic.vue'
import newsletterSystemInfo from '@/components/Newsletters/Page/systemInfo.vue'
import newsletterRcpts from '@/components/Newsletters/Page/rcpts.vue'
import newsletterText from '@/components/Newsletters/Page/text.vue'
import newsletterRating from '@/components/Newsletters/Page/rating.vue'
import newsletterLikes from '@/components/Newsletters/Page/likes.vue'

const newsletterActiveInfoPage: ActiveInfoPageConfig = {
  mapsColumns: {
    lg: [['status', 'statistic', 'rating', 'likes', 'systemInfo'], ['text', 'rcpts']],
    xs: [['text', 'status', 'statistic', 'rating', 'likes', 'rcpts', 'systemInfo']]
  },
  blocks: {
    status: {
      block: newsletterStatus,
      options: {}
    },
    statistic: {
      block: newsletterStatistic,
      options: {}
    },
    systemInfo: {
      block: newsletterSystemInfo,
      options: {}
    },
    rcpts: {
      block: newsletterRcpts,
      options: {}
    },
    text: {
      block: newsletterText,
      options: {}
    },
    rating: {
      block: newsletterRating,
      options: {}
    },
    likes: {
      block: newsletterLikes,
      options: {}
    }
  }
}
export default newsletterActiveInfoPage